<template>
  <div>
    <button
      class="btn btn-icon btn-light-success mr-1"
      type="button"
      v-b-tooltip.noninteractive.hover.left
      title="Configurações"
      @click="abrir()"
    >
      <i class="fa-solid fa-cog"></i>
    </button>

    <b-modal
      ref="mdlConfiguracoesWhatsappOficial"
      title="Perfil do Whatsapp Oficial"
      title-class="text-white"
      header-close-variant="white"
      header-class="whatsapp-info-header"
      @hidden="limpar"
      @ok="salvar"
      @shown="validacao"
      ok-variant="whatsapp"
      ok-title="Atualizar"
      ok-only
      cancel-title="Cancelar"
      body-bg-variant="whatsapp-info"
      footer-bg-variant="whatsapp-info"
      size="lg"
    >
      <b-form ref="frmWhatsapp">
        <div class="d-flex">
          <b-form-group style="flex-shrink: 0; margin-right: 30px">
            <div
              style="
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <div style="position: relative">
                <b-img
                  :src="
                    frmWhatsapp.profile.profile_picture_url ||
                    '/media/comunicante/user-avatar.jpg'
                  "
                  v-blur-sensitive
                  alt="Foto de perfil"
                  width="150"
                  height="150"
                  rounded="circle"
                ></b-img>
                <button
                  class="btn btn-icon btn-light-primary"
                  type="button"
                  @click="uploadImage"
                  v-b-tooltip.noninteractive.hover.left
                  title="Editar foto de perfil"
                  style="
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    border-radius: 100%;
                    background-color: #ff7f00;
                  "
                >
                  <i class="fa-solid fa-camera" style="color: white"></i>
                </button>
              </div>
            </div>
            <input
              ref="inputFile"
              type="file"
              accept="image/jpg, image/jpeg, image/png"
              style="visibility: hidden; width: 0px"
            />
          </b-form-group>
          <b-form-group style="flex-grow: 1">
            <label>Número de telefone</label>
            <b-form-input
              v-blur-sensitive
              name="phone_number"
              :value="conta.phone"
              readonly
              style="cursor: not-allowed; width: 60%"
              :disabled="true"
            ></b-form-input>
            <label class="input-profile">Sobre</label>
            <b-form-textarea
              v-blur-sensitive
              id="description"
              v-model="frmWhatsapp.profile.description"
              placeholder="Escreva uma descrição da sua empresa"
              rows="5"
              maxlength="512"
            ></b-form-textarea>
            <div
              class="text-right"
              style="font-size: 0.85rem; margin-top: 5px; color: #6c757d"
            >
              {{ (frmWhatsapp.profile.description || "").length }}/512
              caracteres
            </div>
            <label class="input-profile">Endereço</label>
            <b-form-input
              v-blur-sensitive
              name="address"
              v-model="frmWhatsapp.profile.address"
            ></b-form-input>
            <label class="input-profile">Sites</label>
            <b-form-input
              v-blur-sensitive
              name="website1"
              v-model="frmWhatsapp.profile.websites[0]"
              placeholder="Digite o site"
              style="margin-bottom: 10px"
            ></b-form-input>
            <b-form-input
              v-blur-sensitive
              name="website2"
              v-model="frmWhatsapp.profile.websites[1]"
              placeholder="Digite o site"
            ></b-form-input>
            <label class="input-profile">Recado:</label>
            <b-form-textarea
              v-blur-sensitive
              name="about"
              v-model="frmWhatsapp.profile.about"
              placeholder="Escreva uma recado da sua empresa"
              rows="2"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group style="flex-shrink: 0; margin-left: 30px">
            <label>Data da migração:</label>
            <b-form-input
              name="last_onboarded_time"
              :value="formatDateToBrazilian(otherInfo.lastOnboardedTime)"
              readonly
              style="cursor: not-allowed"
              :disabled="true"
            ></b-form-input>
            <label class="input-profile">Registrado</label>
            <b-form-checkbox
              v-model="otherInfo.registred"
              switch
              disabled
              style="cursor: not-allowed; font-size: 1.2rem"
              size="lg"
            >
              <span style="font-size: 1.1rem">{{
                otherInfo.registred ? "Sim" : "Não"
              }}</span>
            </b-form-checkbox>
            <label class="input-profile">Limite de mensagens</label>
            <b-form-input
              name="limit_tier"
              :value="otherInfo.limitTier.replace('TIER_', '')"
              readonly
              style="cursor: not-allowed"
              :disabled="true"
            ></b-form-input>
            <label class="input-profile">Classificação de qualidade</label>
            <div
              :style="{
                padding: '0.3rem 0.6rem',
                borderRadius: '0.25rem',
                width: 'fit-content',
                backgroundColor:
                  otherInfo.qualityRating === 'ALTA'
                    ? '#d4edda'
                    : otherInfo.qualityRating === 'MÉDIA'
                    ? '#fff3cd'
                    : '#f8d7da',
                color:
                  otherInfo.qualityRating === 'ALTA'
                    ? '#28a745'
                    : otherInfo.qualityRating === 'MÉDIA'
                    ? '#856404'
                    : '#dc3545'
              }"
            >
              {{ otherInfo.qualityRating }}
            </div>
            <label class="input-profile">Modo da conta</label>
            <div
              :style="{
                padding: '0.3rem 0.6rem',
                borderRadius: '0.25rem',
                width: 'fit-content',
                backgroundColor:
                  otherInfo.accountMode === 'LIVE' ? '#d4edda' : '#fff3cd',
                color: otherInfo.accountMode === 'LIVE' ? '#28a745' : '#856404'
              }"
            >
              {{ otherInfo.accountMode === "LIVE" ? "PRODUÇÃO" : "TESTE" }}
            </div>
          </b-form-group>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import Swal from "sweetalert2";

import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";

import { mapGetters } from "vuex";

export default {
  props: {
    conta: Object
  },

  data() {
    return {
      frmWhatsapp: {
        idConta: null,
        profile: {
          about: "",
          messaging_product: "whatsapp",
          profile_picture_url: "",
          address: "",
          description: "",
          websites: ["", ""]
        }
      },
      otherInfo: {
        lastOnboardedTime: "",
        registred: false,
        limitTier: "",
        qualityRating: "",
        accountMode: ""
      }
    };
  },

  computed: {
    ...mapGetters(["validatorErrors"])
  },

  methods: {
    limpar() {
      this.frmWhatsapp.idConta = null;
      this.frmWhatsapp.profile.about = "";
      this.frmWhatsapp.profile.messaging_product = "whatsapp";
      this.frmWhatsapp.profile.profile_picture_url = "";
      this.frmWhatsapp.profile.address = "";
      this.frmWhatsapp.profile.description = "";
      this.frmWhatsapp.profile.websites = ["", ""];
    },

    abrir() {
      this.limpar();

      this.frmWhatsapp.idConta = this.conta.id;

      ApiService.post("conta/obter-whatsapp-profile", {
        conta_id: this.conta.id
      }).then((response) => {
        const profile = response.data.data;
        const otherInfo = profile.account_informations;

        this.frmWhatsapp.profile.about = profile?.about;

        this.frmWhatsapp.profile.profile_picture_url =
          profile.profile_picture_url;

        this.frmWhatsapp.profile.address = profile.address;
        this.frmWhatsapp.profile.description = profile.description;
        this.frmWhatsapp.profile.websites[0] =
          profile.websites && profile.websites[0] ? profile.websites[0] : "";
        this.frmWhatsapp.profile.websites[1] =
          profile.websites && profile.websites[1] ? profile.websites[1] : "";

        this.otherInfo.lastOnboardedTime = otherInfo.last_onboarded_time;
        this.otherInfo.registred =
          otherInfo.platform_type !== "NOT_APPLICABLE" ? true : false;
        this.otherInfo.limitTier = otherInfo.messaging_limit_tier;
        const qualityRatingMap = {
          GREEN: "ALTA",
          YELLOW: "MÉDIA",
          RED: "BAIXA"
        };
        this.otherInfo.qualityRating =
          qualityRatingMap[otherInfo.quality_rating] ||
          otherInfo.quality_rating;
        this.otherInfo.accountMode = otherInfo.account_mode;

        this.$refs["mdlConfiguracoesWhatsappOficial"].show();
      });
    },

    validacao() {
      const frmWhatsapp = this.$refs["frmWhatsapp"];

      this.fv = formValidation(frmWhatsapp, {
        fields: {
          recado: {
            validators: {
              notEmpty: {
                message: "Campo obrigatório."
              },
              blank: {}
            }
          }
        },
        plugins: {
          trigger: new Trigger(),
          bootstrap: new Bootstrap()
        }
      });
    },

    uploadImage() {
      this.$refs.inputFile.click();

      this.$refs.inputFile.addEventListener("change", this.uploadImageProfile);
    },

    uploadImageProfile(event) {
      const file = event.target.files[0];

      let formData = new FormData();

      formData.append("file", file);
      formData.append("conta_id", this.conta.id);

      ApiService.post("conta/upload-file-whatsapp", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
        .then((response) => {
          this.frmWhatsapp.profile.profile_picture_handle = response.data.data;
        })
        .catch(() => {
          Swal.fire({
            title: "MENSAGEM",
            text: "Erro ao fazer upload da imagem!",
            icon: "error",
            heightAuto: false
          });
        });

      this.frmWhatsapp.profile.profile_picture_url = URL.createObjectURL(file);
    },

    salvar() {
      this.fv.validate().then((status) => {
        if (status == "Valid") {
          ApiService.post("conta/atualizar-whatsapp-profile", {
            ...this.frmWhatsapp,
            conta_id: this.conta.id
          })
            .then(() => {
              this.$emit("aba-alterada", false);

              Swal.fire({
                title: "MENSAGEM",
                text: "Atualizado com sucesso!",
                icon: "success",
                heightAuto: false
              });
            })
            .catch(() => {
              for (const error in this.validatorErrors) {
                this.fv
                  .updateValidatorOption(
                    error,
                    "blank",
                    "message",
                    this.validatorErrors[error]
                  )
                  .updateFieldStatus(error, "Invalid", "blank");
              }
            });
        }
      });
    },
    formatDateToBrazilian(date) {
      if (!date) return "-";

      const parsedDate = new Date(date);
      if (isNaN(parsedDate)) return "-";

      const day = parsedDate.getDate().toString().padStart(2, "0");
      const month = (parsedDate.getMonth() + 1).toString().padStart(2, "0");
      const year = parsedDate.getFullYear();
      const hours = parsedDate.getHours().toString().padStart(2, "0");
      const minutes = parsedDate.getMinutes().toString().padStart(2, "0");
      const seconds = parsedDate.getSeconds().toString().padStart(2, "0");

      return `${day}/${month}/${year} - ${hours}:${minutes}:${seconds}`;
    }
  }
};
</script>

<style>
@font-face {
  font-family: "Gotham Rounded";
  src: url("/fonts/GothamRounded-Medium.otf") format("opentype"),
    url("/fonts/GothamRounded-MediumItalic.otf") format("opentype"),
    url("/fonts/GothamRounded-Light.otf") format("opentype"),
    url("/fonts/GothamRounded-LightItalic.otf") format("opentype"),
    url("/fonts/GothamRounded-Bold.otf") format("opentype"),
    url("/fonts/GothamRounded-BoldItalic.otf") format("opentype"),
    url("/fonts/GothamRounded-Book.otf") format("opentype"),
    url("/fonts/GothamRounded-BookItalic.otf") format("opentype");
}

.ft-whatsapp-info,
.bg-whatsapp-info {
  background-color: #f0f0f0;
}

.whatsapp-info-header {
  color: #fff;
  background-color: #ff7f00;
  font-family: "Gotham Rounded";
}

.input-profile {
  margin-top: 10px;
}

.btn-whatsapp {
  background-color: #462181 !important;
  color: #fff !important;
  border-color: #462181 !important;
}

.btn-whatsapp:hover {
  background-color: #371a66 !important;
  color: #ececec !important;
  border-color: #371a66 !important;
}
</style>
